/* Dropdown */
function toggleDropdown(){
  document.getElementById('cat-trigger').classList.toggle('open');
  document.getElementById('dropdown-menu').classList.toggle('open');
}
document.addEventListener('click',function(e){
  var dd=document.getElementById('cat-dropdown');
  if(dd&&!dd.contains(e.target)){
    document.getElementById('cat-trigger').classList.remove('open');
    document.getElementById('dropdown-menu').classList.remove('open');
  }
});

/* Cart drawer */
function openCart(){
  fetchCartAndRender();
  document.getElementById('cart-panel').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
}
function closeCart(){
  document.getElementById('cart-panel').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
}

function fetchCartAndRender(){
  fetch('/cart.js')
  .then(function(r){return r.json();})
  .then(function(cart){
    var el=document.getElementById('cart-items');
    var count=document.getElementById('cart-count');
    if(count)count.textContent=cart.item_count;

    if(cart.item_count===0){
      el.innerHTML='<div class="cart-empty"><div style="font-size:36px;margin-bottom:0.5rem">🛒</div>Your cart is empty</div>';
      document.getElementById('cart-deal-note').style.display='none';
      document.getElementById('cart-total').textContent='$0.00';
      return;
    }

    el.innerHTML=cart.items.map(function(item){
      var img=item.image?'<img class="cart-item-img" src="'+item.image+'" alt="'+item.title+'">'
        :'<div class="cart-item-img" style="background:#1a1a2e;border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:18px">🌟</div>';
      return '<div class="cart-item">'+img
        +'<div class="cart-item-info"><div class="cart-item-name">'+item.title+'</div>'
        +'<div class="cart-item-price">'+formatMoney(item.price)+'</div></div>'
        +'<button class="cart-item-remove" onclick="removeFromCart(\''+item.key+'\')">✕</button></div>';
    }).join('');

    var note=document.getElementById('cart-deal-note');
    if(cart.item_count>=2){
      note.style.display='block';
      note.textContent='🎉 Buy 1 Get 50% Off is active on your cart!';
    } else {
      note.style.display='none';
    }
    document.getElementById('cart-total').textContent=formatMoney(cart.total_price);
  });
}

function addToCart(btn){
  var id=parseInt(btn.getAttribute('data-id'));
  var orig=btn.textContent;
  btn.textContent='Adding...';
  btn.disabled=true;
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:id,quantity:1})
  })
  .then(function(r){return r.json();})
  .then(function(){
    btn.textContent='Added! ✓';
    fetchCartAndRender();
    openCart();
    setTimeout(function(){btn.textContent=orig;btn.disabled=false;},2500);
  })
  .catch(function(){
    btn.textContent=orig;
    btn.disabled=false;
    alert('Could not add to cart. Please try again.');
  });
}

function removeFromCart(key){
  fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:key,quantity:0})
  })
  .then(function(){fetchCartAndRender();});
}

function formatMoney(cents){
  return '$'+(cents/100).toFixed(2);
}

/* Reviews */
var selStars=0;
function setStars(n){
  selStars=n;
  document.querySelectorAll('.sbtn').forEach(function(b,i){b.classList.toggle('lit',i<n);});
}

var allRevs=[];
function renderRevs(){
  var area=document.getElementById('rev-area');
  if(!area)return;
  if(allRevs.length===0){
    area.innerHTML='<div style="text-align:center;padding:2.5rem;border:0.5px dashed rgba(124,58,237,0.3);border-radius:12px;margin-bottom:2rem"><div style="font-size:32px;margin-bottom:0.5rem">💬</div><div style="font-size:14px;font-weight:600;color:#9ca3af">No reviews yet</div><div style="font-size:12px;color:rgba(156,163,175,0.5);margin-top:4px">Be the first!</div></div>';
  } else {
    area.innerHTML='<div class="rev-grid">'+allRevs.map(function(r){
      return '<div class="rcard"><div class="rstars">'+'★'.repeat(r.stars)+'☆'.repeat(5-r.stars)+'</div>'
        +'<div class="rtext">'+r.text+'</div>'
        +'<div class="rauthor">'+r.name+'</div>'
        +'<div class="rprod">Purchased: '+r.prod+'</div></div>';
    }).join('')+'</div>';
  }
}

function submitRev(){
  var name=document.getElementById('rname').value.trim();
  var prod=document.getElementById('rprod').value;
  var text=document.getElementById('rtext').value.trim();
  if(!name||!prod||!text||selStars===0){alert('Please fill in all fields and select a star rating.');return;}
  allRevs.unshift({name:name,prod:prod,stars:selStars,text:text});
  renderRevs();
  document.getElementById('rname').value='';
  document.getElementById('rprod').value='';
  document.getElementById('rtext').value='';
  setStars(0);
  var ok=document.getElementById('ok-msg');
  ok.style.display='block';
  setTimeout(function(){ok.style.display='none';},4000);
}

document.addEventListener('DOMContentLoaded',function(){
  renderRevs();
  fetchCartAndRender();
});
